// src/components/Pimgy/CloseApplication.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import '../GL/LoanPayment.css';

const CloseApplication = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [closing, setClosing] = useState({});

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/pimgy/active-applications`);
      setApplications(response.data);
    } catch (error) {
      console.error('Error fetching applications:', error);
      alert('Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = async (registrationNo, name) => {
    if (!window.confirm(`Are you sure you want to close the application for ${name} (${registrationNo})? This will prevent further payments.`)) {
      return;
    }

    try {
      setClosing(prev => ({ ...prev, [registrationNo]: true }));
      
      await axios.post(`${API_BASE_URL}/api/pimgy/close-application`, {
        registration_no: registrationNo
      });

      alert('Application closed successfully!');
      
      // Refresh applications list
      fetchApplications();
    } catch (error) {
      console.error('Error closing application:', error);
      alert(error.response?.data?.error || 'Failed to close application');
    } finally {
      setClosing(prev => ({ ...prev, [registrationNo]: false }));
    }
  };

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading applications...</div>;
  }

  return (
    <div className="loan-payment-container">
      <div className="loan-payment-form">
        <h1>Close Application</h1>
        
        {applications.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>No active applications found.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto', marginTop: '20px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Registration No</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Name</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Daily Amount</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Total Paid</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((app) => (
                  <tr key={app.registration_no}>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{app.registration_no}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{app.name}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>
                      ₹{Number(app.daily_amount).toFixed(2)}
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>
                      ₹{Number(app.total_paid || 0).toFixed(2)}
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <button
                        onClick={() => handleClose(app.registration_no, app.name)}
                        disabled={closing[app.registration_no]}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: closing[app.registration_no] ? 'not-allowed' : 'pointer',
                          opacity: closing[app.registration_no] ? 0.6 : 1
                        }}
                      >
                        {closing[app.registration_no] ? 'Closing...' : 'Close'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CloseApplication;

